/* unplugin-vue-components disabled */import script from "./SpotTable.vue?vue&type=script&setup=true&lang=js"
export * from "./SpotTable.vue?vue&type=script&setup=true&lang=js"

import "./SpotTable.vue?vue&type=style&index=0&id=54a5225a&lang=less&scoped=true"

import exportComponent from "/root/workspace/__flow_work/__flow_builds/6e3ae807-c557-4a09-aaa1-df42e37b9e5a/workspace/pc-FTZCOIN_fvgL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54a5225a"]])

export default __exports__